<script>
import { mapMutations } from 'vuex';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  name: 'ModuleExamsEditionAnswer',
  components: {
    CKEditor: CKEditor.component,
  },
  props: {
    item: Object,
    index: Number,
    questionIndex: Number,
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
    };
  },
  computed: {
    answerId() {
      return `answer-${this.questionIndex}-${this.index}`;
    },
    text: {
      get() {
        return this.item.text || '';
      },
      set(value) {
        const { item } = this;
        item.text = value;
        // this.update(item);
      },
    },
    isCorrect: {
      get() {
        return this.item.correct;
      },
      set(value) {
        const { item } = this;
        item.correct = value;
        this.update(item);
      },
    },
  },
  methods: {
    ...mapMutations('exam/item', [
      'updateAnswer',
      'removeAnswer',
    ]),
    remove() {
      this.removeAnswer({
        questionIndex: this.questionIndex,
        index: this.index,
      });
    },
    update(item) {
      this.updateAnswer({
        questionIndex: this.questionIndex,
        index: this.index,
        item,
      });
    },
  },
};
</script>
<template>
    <div class="m-3">
        <div class="d-flex justify-content-between">
            <h1 class="h4 mb-3">Answer {{ index + 1 }}</h1>
            <button class="btn btn-danger" @click="remove">Remove</button>
        </div>
        <div class="form-group mt-3">
            <label :for="`${answerId}-isCorrect`" class="d-block">Is Correct</label>
            <input :id="`${answerId}-isCorrect`" type="checkbox" v-model="isCorrect" />
        </div>
        <div class="form-group mt-3">
            <label :for="`${answerId}-text`" class="d-block">Text</label>
            <CKEditor :id="`${answerId}-text`" :editor="editor" v-model="text" :config="editorConfig" />
        </div>
    </div>
</template>
